import { render, staticRenderFns } from "./NewsPost2.vue?vue&type=template&id=75d1a968&"
import script from "./NewsPost2.vue?vue&type=script&lang=ts&"
export * from "./NewsPost2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports